import { Component, Input, OnInit } from '@angular/core';
import { ApiService }       from '../_services/api.service';
@Component({
  selector: 'f-comment',
  templateUrl: './comment.component.html'
})

export class CommentComponent{

  @Input() name: string;
  comments: any = [];
  model: any = {};
  loading = false;
  submited = false;
  constructor(private apiService: ApiService) {}
  ngOnInit(){
        this.apiService.getComment(this.name).subscribe(result => {
            this.comments = result.comments;
        });
  
  }
  submit(){
    this.model.id = this.name;
    this.model.parent = 0;
    if(this.model.comment != ''){
        this.apiService.submitComment(this.model).subscribe(result => {
            this.loading = false;
            this.submited = true;
            this.comments.unshift(result.comment);
        });
    }
  }
}